import { NgModule } from '@angular/core';
import { FormModule } from 'lib/ui/form/form.module.js';
import { CoreModule } from '../core/core.module.js';
import { SubscriptionModule } from '../modules/subscription/subscription.module.js';
import { UsersModule } from '../modules/users/users.module.js';
import { LayoutCardComponent } from './cards/layout-card.component.js';
import { MainLayoutComponent } from './main-layout.component.js';
import { PrimaryMenuComponent } from './menus/primary-menu.component.js';
import { ToolbarComponent } from './toolbar/toolbar.component.js';
import { LayoutAuthPageComponent } from './types/auth-layout/layout-auth-page.component.js';
import { LayoutCleanPageComponent } from './types/clean/layout-clean-page.component.js';
import { LayoutHomePageComponent } from './types/home/layout-home-page.component.js';

@NgModule({
	declarations: [
		LayoutAuthPageComponent,
		ToolbarComponent,
		MainLayoutComponent,
		LayoutCleanPageComponent,
		LayoutHomePageComponent,
		PrimaryMenuComponent,
		LayoutCardComponent
	],
	exports: [
		LayoutAuthPageComponent,
		ToolbarComponent,
		MainLayoutComponent,
		LayoutCleanPageComponent,
		LayoutHomePageComponent,
		PrimaryMenuComponent,
		LayoutCardComponent
	],

	imports: [CoreModule, SubscriptionModule, UsersModule, FormModule]
})
export class LayoutModule {}
